import FieldBlock from "../../components/CreateClaim/FieldBlock";
import { useFormContext } from "react-hook-form";

function NikonReviewClaimRequest() {
  const { getValues } = useFormContext();

  const data = getValues();
  return (
    <div className="space-y-4">
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8 p-4 border border-gray-300 rounded-lg">
        <div className="text-black font-semibold">Purchase Details</div>
        <div className="space-y-2 mt-2">
          <FieldBlock
            label="Name on the invoice"
            value={data?.purchase_info?.name_on_invoice}
          />
          <FieldBlock
            label="Invoice number"
            value={data?.purchase_info?.invoice_number}
          />
          <FieldBlock
            label="Date of Purchase"
            value={data?.purchase_info?.date_of_purchase}
            date
          />
        </div>
      </div>

      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8 p-4 border border-gray-300 rounded-lg">
        <div className="text-black font-semibold">Customer Details</div>
        <div className="space-y-2 mt-2">
          <FieldBlock label="Customer Name" value={data?.customer_info?.name} />
          <FieldBlock
            label="Customer Email"
            value={data?.customer_info?.email}
          />
          <FieldBlock
            label="Customer Phone"
            value={data?.customer_info?.phone}
          />
          <FieldBlock
            label="Customer Address"
            value={data?.customer_info?.address}
          />
          <FieldBlock label="City" value={data?.customer_info?.city} />
          <FieldBlock label="State" value={data?.customer_info?.state} />
          <FieldBlock label="Zip code" value={data?.customer_info?.zip_code} />
        </div>
      </div>

      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8 p-4 border border-gray-300 rounded-lg">
        <div className="text-black font-semibold">Store Details</div>
        <div className="space-y-2 mt-2">
          <FieldBlock label="Store Name" value={data?.store_info?.name} />
          <FieldBlock label="Store Phone" value={data?.store_info?.phone} />
          <FieldBlock label="Store Address" value={data?.store_info?.address} />
          <FieldBlock label="Store City" value={data?.store_info?.city} />
          <FieldBlock label="Store State" value={data?.store_info?.state} />
          <FieldBlock label="Zip" value={data?.store_info?.zip} />
          <FieldBlock
            label="Were any items exchanged"
            value={data?.store_info?.items_exchanged}
          />
        </div>
      </div>

      {data?.damage?.map((item, index) => (
        <div key={index}>
          <div className="bg-[#EBEEEF] text-black font-semibold min-h-8 rounded flex items-center px-2 gap-2">
            {`Damage ${index + 1}`}
          </div>
          <div className="bg-white grid gap-1.5 divide-y divide-[#F0F0F0] px-2 py-2">
            <FieldBlock label="Product" value={item?.product} />
            <FieldBlock label="Model Number" value={item?.model_number} />
            <FieldBlock label="Serial Number" value={item?.serial_number} />
            <FieldBlock label="Complaint" value={item?.complaint} />
            <FieldBlock
              label="Date of Damage/Discovery"
              value={item?.date_of_damage}
              date
            />
            <FieldBlock label="Cause" value={item?.cause} />
            <FieldBlock label="Customer Action" value={item?.customer_action} />
            <FieldBlock label="Description" value={item?.description} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default NikonReviewClaimRequest;
